import { render, staticRenderFns } from "./SportListLoader.vue?vue&type=template&id=a2c12c08&scoped=true"
import script from "./SportListLoader.vue?vue&type=script&lang=js"
export * from "./SportListLoader.vue?vue&type=script&lang=js"
import style0 from "./SportListLoader.vue?vue&type=style&index=0&id=a2c12c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c12c08",
  null
  
)

export default component.exports